import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { TokenModel } from '@services/auth'

export interface AuthenticationState {
    isAuthenticated: boolean
    user?: TokenModel
    colorMode: 'light' | 'dark'
}

const initialState: AuthenticationState = {
    isAuthenticated: false,
    user: undefined,
    colorMode: 'light',
}

export const authSlice = createSlice({
    name: 'authentication',
    initialState,
    reducers: {
        storeToken: (
            state,
            { payload: tokenModel }: PayloadAction<TokenModel>
        ) => {
            state.user = { ...tokenModel }
            state.isAuthenticated = true
        },
        storeAzureAdToken: (
            state,
            { payload: accessToken }: PayloadAction<string>
        ) => {
            state.user = {
                token: accessToken,
                refreshToken: '',
                firstName: '',
                lastName: '',
                tenantId: '',
                roles: [],
                permissions: [],
                isAzureToken: true,
            }
            state.isAuthenticated = false
        },
        logout: () => initialState,
        setColorMode: (
            state,
            { payload: colorMode }: PayloadAction<'light' | 'dark'>
        ) => {
            state.colorMode = colorMode
        },
    },
})

export const { storeToken, storeAzureAdToken, logout, setColorMode } =
    authSlice.actions
export default authSlice.reducer
